const ERROR_KEYS = {
  code_expired: "authentication.error.code_expired",
  invalid_code: "authentication.error.invalid_code",
  invalid_credentials: "authentication.error.invalid_credentials",
  password_not_set: "authentication.error.password_not_set",
  too_many_attempts: "authentication.error.too_many_attempts",
};

export const getAuthErrorMessage = (code, t) =>
  ERROR_KEYS[code] ? t(ERROR_KEYS[code]) : t("general.something_went_wrong");
